// extracted by mini-css-extract-plugin
module.exports = {"contents":"Pd","sectionHeading":"Qd"};